import { render, staticRenderFns } from "./profil-pr.vue?vue&type=template&id=56538560&scoped=true&"
import script from "./profil-pr.vue?vue&type=script&lang=js&"
export * from "./profil-pr.vue?vue&type=script&lang=js&"
import style0 from "./profil-pr.vue?vue&type=style&index=0&id=56538560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56538560",
  null
  
)

export default component.exports